<script setup>
const props = defineProps({
    asc: {
        type: Boolean,
        default: false,
    }
})
</script>
<template>
    <div class="inline-flex items-center justify-center cursor-pointer text-slate-600">
        <svg xmlns="http://www.w3.org/2000/svg" class="fill-current w-4 h-4 transition duration-300" :class="{
            'rotate-180': asc,
        }" viewBox="0 0 16 16">
            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"/>
          </svg>
    </div>
</template>